import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareTimelineCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-software-timeline-custom-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/:viewId/embed',
	exact: true,
};
